"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = CreditCardForm;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native");
var _isObject = _interopRequireDefault(require("lodash/isObject"));
var _formik = require("formik");
var Yup = _interopRequireWildcard(require("yup"));
var _cardValidator = _interopRequireDefault(require("card-validator"));
var _content = require("@sart/content");
var _utilities = require("@sart/utilities");
var _TextInputExtended = _interopRequireDefault(require("./TextInputExtended"));
var _Label = _interopRequireDefault(require("./Label"));
var _Anchor = _interopRequireDefault(require("./Anchor"));
var _Button = _interopRequireDefault(require("./Button"));
var _Space = _interopRequireDefault(require("./Space"));
var _ErrorMessage = _interopRequireDefault(require("./ErrorMessage"));
var _SwitchExtended = _interopRequireDefault(require("./SwitchExtended"));
var _ReturnFooter = _interopRequireDefault(require("./ReturnFooter"));
var _KeyboardAvoidingView = _interopRequireDefault(require("./KeyboardAvoidingView"));
var _icons = require("@sart/icons");
var _styles = require("@sart/styles");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } // import PropTypes from 'prop-types'
var cheatsheetValues = {
  type: 'visa',
  name: 'MR STEVEN BURNS',
  number: '4124 9399 9999 9990',
  //4124939999999990
  month: '12',
  year: '2025',
  cvv: '100'
};

// Auto Fill Credit Card
// https://cloudfour.com/thinks/autofill-what-web-devs-should-know-but-dont/

function CreditCardForm(props) {
  var _this = this;
  var onCardSubmit = props.onCardSubmit,
    initialValues = props.initialValues,
    storedPayment = props.storedPayment,
    disableStoring = props.disableStoring,
    disableToggleStoring = props.disableToggleStoring,
    allowCheat = props.allowCheat,
    style = props.style,
    labelStyle = props.labelStyle,
    switchStyle = props.switchStyle,
    titleStyle = props.titleStyle,
    disabledStyle = props.disabledStyle,
    enabledStyle = props.enabledStyle,
    thumbColor = props.thumbColor,
    ios_backgroundColor = props.ios_backgroundColor,
    trackColor = props.trackColor,
    onTintColor = props.onTintColor,
    thumbTintColor = props.thumbTintColor,
    tintColor = props.tintColor,
    fourDigit = props.fourDigit,
    injectedContent = props.injectedContent,
    resetStyle = props.resetStyle,
    disabledTitleStyle = props.disabledTitleStyle,
    hasResetButton = props.hasResetButton,
    hasIcon = props.hasIcon,
    placeholderColor = props.placeholderColor,
    labelAndIcon = props.labelAndIcon,
    hasCancelButton = props.hasCancelButton,
    cancelOnPress = props.cancelOnPress,
    cancelStyle = props.cancelStyle,
    cancelContainerStyle = props.cancelContainerStyle,
    submitButtonText = props.submitButtonText,
    monthStyle = props.monthStyle,
    yearStyle = props.yearStyle,
    cvvStyle = props.cvvStyle,
    hasCVVHelp = props.hasCVVHelp,
    helpIcon = props.helpIcon,
    helpOnPress = props.helpOnPress,
    visa = props.visa,
    mastercard = props.mastercard;
  var schema = props.schema;
  var content = injectedContent === undefined ? (0, _content.useContent)() : injectedContent;
  if (!schema) {
    schema = Yup.object().shape({
      name: Yup.string().required(content.forms.required).test('valid-name', content.register_details.noSpecialCharacters, function (value) {
        return validateName(value);
      }),
      number: Yup.string().required(content.forms.required).min(18, content.forms.cardNumberInvalid).max(19, content.forms.cardNumberInvalid) /*.test('test-number', content.forms.cardNumberInvalid, value => validCard.number(value).isValid)*/,
      month: Yup.string().required((0, _content.formatString)(content.forms.isRequired, {
        label: content.forms.monthLabel
      })).test('test-month', content.forms.monthInvalid, function (value) {
        return validMonth(value);
      }),
      year: Yup.string().length(2).required((0, _content.formatString)(content.forms.isRequired, {
        label: content.forms.yearLabel
      })).test('test-year', content.payment_method.yearValid, function (value) {
        return validDate(value);
      }),
      cvv: Yup.string().min(3).max(4).required((0, _content.formatString)(content.forms.isRequired, {
        label: content.forms.cvvLabel
      })).test('cvv-check', content.payment_method.cvvValid, function (value) {
        return validCVV(value);
      }),
      type: Yup.string(),
      differentBillingAddress: Yup["boolean"](),
      address1: Yup.string(),
      address2: Yup.string(),
      city: Yup.string(),
      county: Yup.string(),
      postcode: Yup.string(),
      country: Yup.string(),
      amount: Yup.number()
    });
  }
  var currentDate = new Date();
  currentDate.setDate(1);
  var _React$useState = _react["default"].useState(false),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    autofilled = _React$useState2[0],
    setautoFilled = _React$useState2[1];
  var formik = (0, _formik.useFormik)({
    initialValues: _objectSpread({
      name: '',
      number: '',
      month: '',
      year: '',
      cvv: '',
      type: '',
      store: '',
      differentBillingAddress: false,
      address1: '',
      address2: '',
      city: '',
      county: '',
      postcode: '',
      country: ''
    }, initialValues),
    validationSchema: schema,
    onSubmit: function onSubmit(values, form) {
      values.number = values.number.replace(/ /g, "");
      return onCardSubmit(values, form);
    }
  });
  _react["default"].useEffect(function () {
    if (storedPayment) {
      formik.setValues(_objectSpread(_objectSpread({}, storedPayment), {}, {
        store: true
      }), false);
      setautoFilled(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  function validateName(value) {
    if (value) {
      if (value.match(/^[A-Za-zÀ-ÖØ-öø-ÿ0-9\s'-]+$/)) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }
  function validDate(value) {
    var expiryDate = new Date();
    expiryDate.setDate(1);
    expiryDate.setMonth(formik.values.month - 1);
    expiryDate.setFullYear("20" + value);
    if (value) {
      if (value.match(/^\d{1,2}$/)) {
        if (expiryDate < currentDate) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    } else {
      return true;
    }
  }
  function validMonth(value) {
    if (value) {
      if (value.match(/^\d{1,2}$/)) {
        if (value < 13 && value > 0) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } else {
      return true;
    }
  }
  function validCVV(value) {
    var numberValidation = _cardValidator["default"].number(formik.values.number);
    if (value) {
      if (numberValidation.card && numberValidation.card.type === 'american-express') {
        if (value.match(/^\d{4}$/)) {
          return true;
        } else {
          return false;
        }
      } else {
        if (value.match(/^\d{3}$/)) {
          return true;
        } else {
          return false;
        }
      }
    } else {
      return true;
    }
  }
  function handleAutofillCheat() {
    formik.setValues(_objectSpread(_objectSpread({}, cheatsheetValues), {}, {
      store: formik.initialValues.store
    }), false); // should not validate
  }
  function handleReset() {
    formik.handleReset();
    setautoFilled(false);
  }
  var groupErrorMessage = formik.touched.month && formik.errors.month || formik.touched.year && formik.errors.year || formik.touched.cvv && formik.errors.cvv;
  return /*#__PURE__*/_react["default"].createElement(_KeyboardAvoidingView["default"], null, initialValues && initialValues.amount && /*#__PURE__*/_react["default"].createElement(_TextInputExtended["default"]
  // ref={numberRef}
  , (0, _extends2["default"])({
    label: content.forms.payAmountLabel,
    value: formik.values.amount,
    placeholder: content.forms.payAmountPlaceholder,
    error: formik.touched.amount && formik.errors.amount
  }, _reactNative.Platform.select({
    web: {
      autoComplete: "cc-amount"
    },
    ios: {
      keyboardType: "decimal-pad"
    },
    android: {
      keyboardType: "amount-pad"
    }
  }), {
    onChangeText: formik.handleChange('amount'),
    onBlur: formik.handleBlur('amount'),
    disabled: autofilled,
    placeholderColor: placeholderColor,
    style: style,
    labelStyle: labelStyle
  })), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 16
  }), labelAndIcon && /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: {
      flexDirection: 'row'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Label["default"], {
    style: labelStyle
  }, content.forms.cardNumberLabel), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    width: 8
  }), visa, /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    width: 8
  }), mastercard, /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 32
  })), /*#__PURE__*/_react["default"].createElement(_TextInputExtended["default"]
  // ref={numberRef}
  , (0, _extends2["default"])({
    label: labelAndIcon ? null : content.forms.cardNumberLabel,
    value: formik.values.number,
    placeholder: content.forms.cardNumberPlaceholder,
    icon: hasIcon ? function (_ref) {
      var color = _ref.color;
      return /*#__PURE__*/_react["default"].createElement(_icons.CreditCartType, {
        type: formik.values.type,
        color: color
      });
    } : null,
    error: formik.touched.number && formik.errors.number
  }, _reactNative.Platform.select({
    web: {
      autoComplete: "cc-number"
    },
    ios: {
      keyboardType: "number-pad"
    },
    android: {
      autoCompleteType: "cc-number",
      keyboardType: "number-pad"
    }
  }), {
    onChangeText: function onChangeText(text) {
      // Spacing for American Express cards - Looks a bit awkward though
      // let formattedText = text.replace(/[^\d]?/g, '').replace(/(\d{4})(\d{6})(\d{5})/g, '$1 $2 $3 ').trim()
      var formattedText = text.replace(/[^\d]?/g, '').replace(/(\d{4})/g, '$1 ').trim();
      formik.handleChange('number')(formattedText);
      formik.setFieldValue('type', (0, _utilities.guessCardType)(formattedText));
    },
    onBlur: formik.handleBlur('number'),
    disabled: autofilled,
    maxLength: 19
    ////edit thissssss
    ,
    placeholderColor: placeholderColor,
    style: style,
    labelStyle: labelStyle
  }, _reactNative.Platform.OS === 'web' ? {
    onSubmitEditing: formik.handleSubmit
  } : {
    returnKeyType: "next",
    onSubmitEditing: function onSubmitEditing() {
      return _this.nameRef.focus();
    }
  })), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 16
  }), /*#__PURE__*/_react["default"].createElement(_TextInputExtended["default"]
  // ref={nameRef}
  , (0, _extends2["default"])({
    label: content.forms.nameOnCardLabel,
    placeholder: content.forms.nameOnCardPlaceholder,
    value: formik.values.name,
    error: formik.touched.name && formik.errors.name,
    keyboardType: "default"
    // returnKeyType="next"
    // blurOnSubmit={false}
    // onSubmitEditing={() => {
    //   numberRef.current.focus()
    // }}
    // autoCapitalize="words"
  }, _reactNative.Platform.select({
    web: {
      autoComplete: "cc-name"
    },
    // ios: { textContentType: "cc-name" },
    android: {
      autoCompleteType: "name"
    }
  }), {
    onChangeText: formik.handleChange('name'),
    onBlur: formik.handleBlur('name'),
    disabled: autofilled,
    style: style,
    labelStyle: labelStyle,
    placeholderColor: placeholderColor
    // {...Platform.OS === 'web' ? {ref:{(ref) => { this.nameRef = ref }}}: {} }
    //  ref={Platform.OS === 'web' ? {} : ref => {
    //    this.nameRef = ref;
    //  }}
  }, _reactNative.Platform.OS === 'web' ? {
    onSubmitEditing: formik.handleSubmit
  } : {
    returnKeyType: "next",
    onSubmitEditing: function onSubmitEditing() {
      return _this.monthRef.focus();
    }
  })), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 8
  }), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.dateandcvv
  }, /*#__PURE__*/_react["default"].createElement(_TextInputExtended["default"], (0, _extends2["default"])({
    wrapperStyle: styles.inputs,
    label: content.forms.monthLabel,
    placeholder: content.forms.monthPlaceholder,
    value: formik.values.month,
    hideError: true,
    error: formik.touched.month && formik.errors.month
    // keyboardType="number-pad"
  }, _reactNative.Platform.select({
    web: {
      autoComplete: "cc-exp-month"
    },
    // ios: { textContentType: "cc-exp-month" },
    android: {
      autoCompleteType: "cc-exp-month"
    }
  }), {
    maxLength: 2,
    onChangeText: formik.handleChange('month'),
    onBlur: formik.handleBlur('month'),
    disabled: autofilled,
    style: monthStyle ? monthStyle : style,
    labelStyle: labelStyle
    //ref={Platform.OS === 'web' ? {} : ref => {
    //  this.monthRef = ref;
    //}}
    ,
    placeholderColor: placeholderColor
  }, _reactNative.Platform.OS === 'web' ? {
    onSubmitEditing: formik.handleSubmit
  } : {
    returnKeyType: "next",
    onSubmitEditing: function onSubmitEditing() {
      return _this.yearRef.focus();
    }
  })), /*#__PURE__*/_react["default"].createElement(_TextInputExtended["default"], (0, _extends2["default"])({
    wrapperStyle: styles.inputs,
    label: content.forms.yearLabel,
    placeholder: fourDigit ? content.forms.yearPlaceholder : content.forms.yearPlaceHolderTwoDigit,
    value: formik.values.year,
    hideError: true,
    error: formik.touched.year && formik.errors.year
    // keyboardType="number-pad"
  }, _reactNative.Platform.select({
    web: {
      autoComplete: "cc-exp-year"
    },
    // ios: { textContentType: "cc-exp-year" },
    android: {
      autoCompleteType: "cc-exp-year"
    }
  }), {
    maxLength: 4,
    onChangeText: formik.handleChange('year'),
    onBlur: formik.handleBlur('year'),
    disabled: autofilled,
    style: yearStyle ? yearStyle : style,
    labelStyle: labelStyle
    //ref={Platform.OS === 'web' ? {} : ref => {
    //  this.yearRef = ref;
    //}}
    ,
    placeholderColor: placeholderColor
  }, _reactNative.Platform.OS === 'web' ? {
    onSubmitEditing: formik.handleSubmit
  } : {
    returnKeyType: "next",
    onSubmitEditing: function onSubmitEditing() {
      return _this.cvvRef.focus();
    }
  })), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    width: 4
  }), /*#__PURE__*/_react["default"].createElement(_TextInputExtended["default"], (0, _extends2["default"])({
    wrapperStyle: styles.inputs,
    label: content.forms.cvvLabel,
    placeholder: content.forms.cvvPlaceholder,
    value: formik.values.cvv,
    hideError: true,
    error: formik.touched.cvv && formik.errors.cvv
    // keyboardType="number-pad"
  }, _reactNative.Platform.select({
    web: {
      autoComplete: "cc-csc"
    },
    // ios: { textContentType: "cc-csc" },
    android: {
      autoCompleteType: "cc-csc"
    }
  }), {
    maxLength: 4,
    onChangeText: formik.handleChange('cvv'),
    onBlur: formik.handleBlur('cvv'),
    disabled: autofilled,
    style: cvvStyle ? cvvStyle : style,
    labelStyle: labelStyle,
    returnKeyType: "go"
    //ref={Platform.OS === 'web' ? {} : ref => {
    //  this.cvvRef = ref;
    //}}
    ,
    placeholderColor: placeholderColor,
    onSubmitEditing: formik.handleSubmit
  })), hasCVVHelp && /*#__PURE__*/_react["default"].createElement(_reactNative.TouchableOpacity, {
    onPress: helpOnPress,
    style: {
      justifyContent: 'flex-end',
      padding: 0,
      margin: 0
    }
  }, helpIcon)), groupErrorMessage && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 8
  }), /*#__PURE__*/_react["default"].createElement(_ErrorMessage["default"], {
    style: styles.errormessage
  }, groupErrorMessage)), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 24
  }), !disableStoring && /*#__PURE__*/_react["default"].createElement(_SwitchExtended["default"], {
    label: content.forms.saveCardLabel,
    description: content.forms.saveCardSubtext,
    value: formik.values.store,
    disabled: disableToggleStoring || autofilled,
    onValueChange: function onValueChange(value) {
      return formik.setFieldValue('store', value);
    },
    fontStyle: switchStyle,
    trackColor: trackColor,
    ios_backgroundColor: ios_backgroundColor,
    thumbColor: thumbColor,
    onTintColor: onTintColor,
    thumbTintColor: thumbTintColor,
    tintColor: tintColor
  }), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 4
  }), hasCancelButton && /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: {
      flexDirection: 'row'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    title: content.common.cancel,
    titleStyle: cancelStyle,
    style: cancelContainerStyle,
    onPress: cancelOnPress
  }), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    width: '2%'
  }), /*#__PURE__*/_react["default"].createElement(_Button["default"], (0, _extends2["default"])({
    title: submitButtonText,
    disabled: !formik.isValid || formik.isSubmitting,
    onPress: formik.handleSubmit
  }, allowCheat && {
    onLongPress: handleAutofillCheat
  }, style && {
    style: enabledStyle,
    disabledStyle: disabledStyle
  }, {
    titleStyle: titleStyle,
    disabledTitleStyle: disabledTitleStyle
  }, (0, _utilities.testID)('CardOptionButton')))), !hasCancelButton && /*#__PURE__*/_react["default"].createElement(_Button["default"], (0, _extends2["default"])({
    title: formik.isSubmitting ? content.common.submitting : content.common.submit,
    disabled: !formik.isValid || formik.isSubmitting,
    onPress: formik.handleSubmit
  }, allowCheat && {
    onLongPress: handleAutofillCheat
  }, style && {
    style: enabledStyle,
    disabledStyle: disabledStyle
  }, {
    titleStyle: titleStyle,
    disabledTitleStyle: disabledTitleStyle
  }, (0, _utilities.testID)('CardOptionButton'))), hasResetButton && /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [styles.centered, resetStyle]
  }, /*#__PURE__*/_react["default"].createElement(_Anchor["default"], {
    style: _objectSpread({}, _styles.typography.medium),
    title: content.common.reset,
    onPress: handleReset,
    disabled: !autofilled
  })));
}
CreditCardForm.defaultProps = {
  allowCheat: process.env.NODE_ENV === "development",
  hasResetButton: true,
  hasIcon: true,
  labelAndIcon: false,
  hasCancelButton: false,
  hasCVVHelp: false
};
var styles = _reactNative.StyleSheet.create({
  // container: {},
  dateandcvv: {
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  inputs: {
    flex: 0.3
  },
  errormessage: {
    textAlign: 'left'
  },
  // button: {
  //   backgroundColor:colors.white
  // },
  centered: {
    justifyContent: 'center',
    alignItems: 'center',
    padding: 12
  }
});